export default "__VITE_ASSET__CuyR1_UU__"